//HATSA ACA ESTA VERSIÓN 1.0, SI FUNCIONA CAMBIAMOS A 1.1
import React, { useReducer, useRef, useEffect } from "react";

import CalendarioContext from "./CalendarioContext";
import CalendarioReducer from "./CalendarioReducer";

import { LISTAR_CITAS, FILTRO_CITAS_ESPACIOS, FILTRO_CITAS_PACIENTES, FILTRO_CITAS_ASEGURADORAS } from "../../types";

import clienteAxios from "../../config/axios";

export default function CalendarioState(props) {
  const initialState = {  
    citas: [],
    filtroCitasEspacios: null,
    filtroCitasPacientes: null,
  };

  const [state, dispatch] = useReducer(CalendarioReducer, initialState);
  const updatedSinceRef = useRef(null);
  useEffect(() => { updatedSinceRef.current = new Date().toISOString(); }, []);
  
  const listarCitas = async (fechaBusqueda, espacios, pacientes, AseguradorasPar,todosEspacios, todosPacientes, porAseguradora) => {
    const checkedEspacios = espacios && espacios.length > 0 ? espacios : [];

    const res = await clienteAxios.post(
      "/agenda/filtro/citas",
      {
        incluirTratamientos: false,
        espaciosVo: checkedEspacios,
        pacientesVo: pacientes,
        //aseguradorasVo: aseguradorasRegisro,
        aseguradorasVo: AseguradorasPar,
        todosEspacios: todosEspacios,
        todosPacientes: todosPacientes,
        fechaBusqueda: fechaBusqueda,
        porAseguradora: porAseguradora,
      },
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          'Cache-Control': 'no-store', // Evita el caché del navegador
        },
      }
    );
   /* res.data TRAE LA DESCRIPCION DE NOMBRE, MEDICO Y TIPO DE CONSULTA Y LO DIBUJA COLOR UVA   */
    if (res.data) {
      //alert(res.data.length)
      res.data = res.data.map((cita) => {
        let className = "font-bold bg-purple";
        if (cita.extendedProps.color != "") {
          className = cita.extendedProps.color;
        }

        let textColor = "white"; // Default to automatic text color
        switch (className) {
          case "font-bold bg-yellow":
            textColor = "black";
            break;
          default:
            break;
        }
        return { ...cita, className, textColor };
      });
    }

    dispatch({
      type: LISTAR_CITAS,
      payload: res.data,
    });
    return res.data;
  };

  const setFiltroCitasEspacios = async (filtroCitasEspacios) => {
    dispatch({
      type: FILTRO_CITAS_ESPACIOS,
      payload: filtroCitasEspacios,
    });

    return true;
  };

  const setFiltroCitasPacientes = async (filtroCitasPacientes) => {
    dispatch({
      type: FILTRO_CITAS_PACIENTES,
      payload: filtroCitasPacientes,
    });

    return true;
  };

  const setFiltroCitasAseguradoras = async (filtroCitasAseguradoras) => {
    dispatch({
      type: FILTRO_CITAS_ASEGURADORAS,
      payload: filtroCitasAseguradoras,
    });

    return true;
  };
 
  const uploadCita = async (cita) => {
    try {
      const res = await clienteAxios.post(`/agenda/cita/guardar`, cita, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          'Cache-Control': 'no-store', // Evita el caché del navegador
        },
      });

      //Aqui checo si la cita esta en la lista, si no esta la agrego, y si esta la remplazo con los cambios
      let citas;

      const citaEdited = state.citas.filter((cita) => cita.id == res.data.id)[0];

      if (!citaEdited) {
        citas = state.citas.concat(res.data);
      } else {
        citas = state.citas.map((cita) => {
          if (cita.id == res.data.id) {
            cita = res.data;
          }
          return cita;
        });
      }

      dispatch({
        type: LISTAR_CITAS,
        payload: citas,
      });

      return res;
    } catch (error) {
      // dispatch({
      //     type: ERROR_UPLOAD_ORDEN_COMPRA,
      //     payload: null
      // })

      if (!error.response) {
        error.response = {
          data: {
            message: "Fallo en la conexión al servidor",
            error: "hubo error",
            errorConexion: true,
          },
        };
      }

      return error.response;
    }

    // if(cita.id){

    //     const citas = await state.citas.map( (env) =>  {
    //         if(env.id == cita.id){
    //             env.start = cita.start
    //             env.end = cita.end
    //             env.title = cita.title
    //             env.extendedProps = {
    //                 espacio: cita.espacio,
    //                 cliente: cita.cliente,
    //                 comentarios: cita.comentarios,
    //             }
    //             return env;
    //         }else{
    //             return env
    //         }
    //     })
    //     dispatch({
    //         type: LISTAR_CITAS,
    //         payload: citas
    //     })

    // }else{

    //     let id = state.citas[state.citas.length -1].id +1;

    //     let nueva = {
    //         id:id,
    //         title: cita.title,
    //         start: cita.start,
    //         end: cita.end,
    //         // className: "bg-osvaldo",
    //         color: 'blue',
    //         extendedProps: {
    //             espacio: cita.espacio,
    //             cliente: cita.cliente,
    //             comentarios: cita.comentarios,
    //         }
    //     }
    //     dispatch({
    //         type: LISTAR_CITAS,
    //         payload: [...state.citas, nueva]
    //     })

    // }
  };

  const deleteCita = async (cita) => {
    try {
      const res = await clienteAxios.post(`/agenda/cita/eliminar`, cita, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          'Cache-Control': 'no-store', // Evita el caché del navegador
        },
      });

      const citas = await state.citas.filter((env) => env.id != cita.id);

      dispatch({
        type: LISTAR_CITAS,
        payload: citas,
      });

      return res;
    } catch (error) {
      if (!error.response) {
        error.response = {
          data: {
            message: "Fallo en la conexión al servidor",
            error: "hubo error",
          },
        };
      }

      return error.response;
    }
  };
  
  const exportAgenda = async (filtrosImpresion) => {
    try {
      const res = await clienteAxios.post("/agenda/export", filtrosImpresion, {
        responseType: "arraybuffer",
        headers: {
          "Content-Disposition": "attachment; filename=agenda.pdf",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          'Cache-Control': 'no-store', // Evita el caché del navegador
        },
      });

        var file = new Blob([res.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);

      return res;
    } catch (error) {
      if (!error.response) {
        error.response = {
          data: {
            message: "Fallo en la conexión al servidor",
            error: "hubo error",
          },
        };
      } else {
        error.response = {
          data: {
            message: "Error, por favor inténtalo más tarde",
            error: "Error",
          },
        };
      }

      return error.response;
    }
  };

  const exportAgendaPorDia = async (filtrosImpresion) => {
    try {
      const res = await clienteAxios.post("/agenda/export/dia", filtrosImpresion, {
        responseType: "arraybuffer",
        headers: {
          "Content-Disposition": "attachment; filename=agenda.pdf",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          'Cache-Control': 'no-store', // Evita el caché del navegador
        },
      });

      var file = new Blob([res.data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);

      return res;
    } catch (error) {
      if (!error.response) {
        error.response = {
          data: {
            message: "Fallo en la conexión al servidor",
            error: "hubo error",
          },
        };
      } else {
        error.response = {
          data: {
            message: "Error, por favor inténtalo más tarde",
            error: "Error",
          },
        };
      }

      return error.response;
    }
  };

  const listarCitasPaciente = async (idCatPaciente) => {
    const res = await clienteAxios.post(
      "/agenda/paciente/citas",
      {
        idCatPaciente: idCatPaciente,
      },
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          'Cache-Control': 'no-store', // Evita el caché del navegador
        },
      }
    );
    //console.log("🚀 ~ file: CalendarioState.js:293 ~ listarCitasPaciente ~ res:", res);

    return res;
  };

  const traerCita = async (id) => {
    const res = await clienteAxios.get(`/agenda/cita/${id}`, { 
      headers: {
        "Access-Control-Allow-Origin": "*",
        'Cache-Control': 'no-store', // Evita el caché del navegador
      },
    });
    return res.data;
  };

  const patchCitaEnLista = (citaActualizada) => {
    const existe = state.citas.some(c => c.id == citaActualizada.id);
  
    const citas = existe
      ? state.citas.map((prev) => {
          if (prev.id != citaActualizada.id) return prev;
  
          const next = citaActualizada || {};
  
          // 🎨 Estilos
          const colorNext = next?.extendedProps?.color;
          const colorPrev = prev?.extendedProps?.color;
  
          // Si el back NO manda color, conservamos el estilo previo
          const classNameFinal =
            (colorNext ? colorNext : (next.className ?? prev.className ?? "font-bold bg-purple"));
  
          const textColorFinal = next.textColor ?? prev.textColor ?? "white";
  
          return {
            // Base previa + datos nuevos
            ...prev,
            ...next,
  
            // Fechas: no las pierdas si el fresh no las trae
            start: next.start ?? prev.start,
            end:   next.end   ?? prev.end,
  
            // Estilos resueltos
            className: classNameFinal,
            textColor: textColorFinal,
  
            // extendedProps: merge y conserva color si el fresh no lo trae
            extendedProps: {
              ...prev.extendedProps,
              ...next.extendedProps,
              color: colorNext ?? colorPrev ?? "",
            },
          };
        })
      : state.citas.concat(citaActualizada);
  
    dispatch({ type: LISTAR_CITAS, payload: citas });
  };
  
  // AUTO REFRESH

    // Helpers (en el Context)
  const toDate = (d) => (d ? new Date(d) : null);

  const getMaxUpdatedAt = (arr, fallback) =>
    arr.reduce((max, ev) => {
      const u = toDate(ev.updatedAt)?.getTime?.() ?? 0;
      return u > max ? u : max;
    }, fallback ? new Date(fallback).getTime() : 0);

  const applyFrontendClasses = (ev) => {
    let className = "font-bold bg-purple";
    if (ev?.extendedProps?.color) className = ev.extendedProps.color;
    let textColor = className === "font-bold bg-yellow" ? "black" : "white";
    return { ...ev, className, textColor };
  };

  const mergeCitas = (prevCitas = [], cambios = [], idsEnEdicion = new Set()) => {
    const byId = new Map(prevCitas.map((e) => [String(e.id), e]));
  
    for (const incoming of cambios) {
      const id = String(incoming?.id || "");
      if (!id || idsEnEdicion.has(id)) continue;
  
      // 🪦 tombstone: eliminar del mapa y seguir
      if (incoming.eliminada === true) {
        byId.delete(id);
        continue;
      }
  
      const curr  = byId.get(id);
      const uIn   = (incoming.updatedAt ? new Date(incoming.updatedAt).getTime() : 0);
      const uCurr = (curr?.updatedAt ? new Date(curr.updatedAt).getTime() : 0);
  
      if (!curr) {
        byId.set(id, applyFrontendClasses(incoming));
      } else if (uIn > uCurr) {
        byId.set(id, applyFrontendClasses({ ...curr, ...incoming }));
      }
    }
  
    return Array.from(byId.values());
  };
  

  // Ya tienes listarCitas; agrega listarCitasChange:
  const listarCitasChange = async (payload) => {
    const {
      viewStart, viewEnd, limit = 300,
      espacios, pacientes, aseguradoras,
      todosEspacios, todosPacientes, porAseguradora,
    } = payload;
  
    const checkedEspacios = Array.isArray(espacios) && espacios.length > 0 ? espacios : [];
  
    const res = await clienteAxios.post(
      "/agenda/citas/changes",
      {
        viewStart,
        viewEnd,
        updatedSince: updatedSinceRef.current, // ← usa el cursor persistente
        limit,
        incluirInactivas: false,               // ← paridad con carga general
        incluirTratamientos: false,
        espaciosVo: checkedEspacios,
        pacientesVo: pacientes,
        aseguradorasVo: aseguradoras,
        todosEspacios,
        todosPacientes,
        porAseguradora,
      },
      { headers: { "Access-Control-Allow-Origin": "*", "Cache-Control": "no-store" } }
    );
  
    const data = (Array.isArray(res.data) ? res.data : []).map((ev) => {
      if (ev && ev.eliminada === true) {
        return { id: ev.id, eliminada: true, updatedAt: ev.updatedAt };
      }
      return applyFrontendClasses(ev);
    });
  
    return data;
  };
  
  

  // NUEVO: función del Context que trae cambios, hace MERGE y hace DISPATCH
  const fetchAndApplyCitasChanges = async (payload, { idsEnEdicion = new Set() } = {}) => {
    const cambios = await listarCitasChange(payload); // usa el cursor interno (updatedSinceRef)
  
    // merge sobre el estado actual del context
    const merged = mergeCitas(state.citas, cambios, idsEnEdicion);
    dispatch({ type: LISTAR_CITAS, payload: merged });
  
    // avanzar cursor incremental
    const maxU = getMaxUpdatedAt(cambios, updatedSinceRef.current);
    if (maxU > 0) {
      updatedSinceRef.current = new Date(maxU).toISOString();
    }
  
    return {
      cambiosCount: cambios.length,
      maxUpdatedAtISO: maxU > 0 ? new Date(maxU).toISOString() : updatedSinceRef.current,
    };
  };

  
  return (
    <CalendarioContext.Provider
      value={{
        citas: state.citas,
        filtroCitasEspacios: state.filtroCitasEspacios,
        filtroCitasPacientes: state.filtroCitasPacientes,
        filtroCitasAseguradoras: state.setFiltroCitasAseguradoras,
        setFiltroCitasEspacios,
        setFiltroCitasPacientes,
        setFiltroCitasAseguradoras,
        listarCitas,
        fetchAndApplyCitasChanges,
        uploadCita,
        deleteCita,
        patchCitaEnLista,
        exportAgenda,
        exportAgendaPorDia,
        listarCitasPaciente,
        traerCita,       
      }}>
      {props.children}
    </CalendarioContext.Provider>
  );
}
